export default "/images/tag-master.svg?3ce8f826f15c406748c70996eb8b0d99";